export const OsmosisTestnetChainInfo = {
  // Chain-id of the Osmosis chain.
  chainId: "osmo-test-5",
  // The name of the chain to be displayed to the user.
  chainName: "Osmosis Testnet",
  // RPC endpoint of the chain. In this case we are using blockapsis, as it's accepts connections from any host currently. No Cors limitations.
  rpc: "https://rpc.osmotest5.osmosis.zone",
  // REST endpoint of the chain.
  rest: "https://lcd.osmotest5.osmosis.zone",
  // Staking coin information
  stakeCurrency: {
    // Coin denomination to be displayed to the user.
    coinDenom: "OSMO",
    // Actual denom (i.e. uatom, uscrt) used by the blockchain.
    coinMinimalDenom: "uosmo",
    // # of decimal points to convert minimal denomination to user-facing denomination.
    coinDecimals: 6,
    // (Optional) Keplr can show the fiat value of the coin if a coingecko id is provided.
    // You can get id from https://api.coingecko.com/api/v3/coins/list if it is listed.
    // coinGeckoId: ""
  },
  // (Optional) If you have a wallet webpage used to stake the coin then provide the url to the website in `walletUrlForStaking`.
  // The 'stake' button in Keplr extension will link to the webpage.
  // walletUrlForStaking: "",
  // The BIP44 path.
  bip44: {
    // You can only set the coin type of BIP44.
    // 'Purpose' is fixed to 44.
    coinType: 118,
  },
  // Bech32 configuration to show the address to user.
  // This field is the interface of
  // {
  //   bech32PrefixAccAddr: string;
  //   bech32PrefixAccPub: string;
  //   bech32PrefixValAddr: string;
  //   bech32PrefixValPub: string;
  //   bech32PrefixConsAddr: string;
  //   bech32PrefixConsPub: string;
  // }
  bech32Config: {
    bech32PrefixAccAddr: "osmo",
    bech32PrefixAccPub: "osmopub",
    bech32PrefixValAddr: "osmovaloper",
    bech32PrefixValPub: "osmovaloperpub",
    bech32PrefixConsAddr: "osmovalcons",
    bech32PrefixConsPub: "osmovalconspub",
  },
  // List of all coin/tokens used in this chain.
  currencies: [
    {
      // Coin denomination to be displayed to the user.
      coinDenom: "OSMO",
      // Actual denom (i.e. uatom, uscrt) used by the blockchain.
      coinMinimalDenom: "uosmo",
      // # of decimal points to convert minimal denomination to user-facing denomination.
      coinDecimals: 6,
      // (Optional) Keplr can show the fiat value of the coin if a coingecko id is provided.
      // You can get id from https://api.coingecko.com/api/v3/coins/list if it is listed.
      // coinGeckoId: ""
    },
  ],
  // List of coin/tokens used as a fee token in this chain.
  feeCurrencies: [
    {
      // Coin denomination to be displayed to the user.
      coinDenom: "OSMO",
      // Actual denom (i.e. uosmo, uscrt) used by the blockchain.
      coinMinimalDenom: "uosmo",
      // # of decimal points to convert minimal denomination to user-facing denomination.
      coinDecimals: 6,
      // (Optional) Keplr can show the fiat value of the coin if a coingecko id is provided.
      // You can get id from https://api.coingecko.com/api/v3/coins/list if it is listed.
      // coinGeckoId: ""
      // (Optional) This is used to set the fee of the transaction.
      // If this field is not provided and suggesting chain is not natively integrated, Keplr extension will set the Keplr default gas price (low: 0.01, average: 0.025, high: 0.04).
      // Currently, Keplr doesn't support dynamic calculation of the gas prices based on on-chain data.
      // Make sure that the gas prices are higher than the minimum gas prices accepted by chain validators and RPC/REST endpoint.
      gasPriceStep: {
        low: 0.0025,
        average: 0.025,
        high: 0.04,
      },
    },
  ],
};

export const OsmosisChainInfo = {
  rpc: "https://rpc-osmosis.keplr.app",
  rest: "https://lcd-osmosis.keplr.app",
  chainId: "osmosis-1",
  chainName: "Osmosis",
  stakeCurrency: {
    coinDenom: "OSMO",
    coinMinimalDenom: "uosmo",
    coinDecimals: 6,
    coinGeckoId: "osmosis",
  },
  bip44: { coinType: 118 },
  bech32Config: {
    bech32PrefixAccAddr: "osmo",
    bech32PrefixAccPub: "osmopub",
    bech32PrefixValAddr: "osmovaloper",
    bech32PrefixValPub: "osmovaloperpub",
    bech32PrefixConsAddr: "osmovalcons",
    bech32PrefixConsPub: "osmovalconspub",
  },
  currencies: [
    {
      coinDenom: "OSMO",
      coinMinimalDenom: "uosmo",
      coinDecimals: 6,
      coinGeckoId: "osmosis",
    },
    {
      coinDenom: "ION",
      coinMinimalDenom: "uion",
      coinDecimals: 6,
      coinGeckoId: "ion",
    },
  ],
  feeCurrencies: [
    {
      coinDenom: "OSMO",
      coinMinimalDenom: "uosmo",
      coinDecimals: 6,
      coinGeckoId: "osmosis",
      gasPriceStep: {
        low: 0,
        average: 0.025,
        high: 0.04,
      },
    },
  ],
  features: [
    "ibc-transfer",
    "ibc-go",
    "cosmwasm",
    "wasmd_0.24+",
    "osmosis-txfees",
  ],
};

export const ZetaChainInfo = {
  chainId: "zetachain_7000-1",
  chainName: "ZetaChain",
  rpc: "https://rpc-zetachain.keplr.app",
  rest: "https://lcd-zetachain.keplr.app",
  stakeCurrency: {
    coinDenom: "ZETA",
    coinMinimalDenom: "azeta",
    coinDecimals: 18,
    coinGeckoId: "zetachain",
  },
  bip44: { coinType: 60 },
  bech32Config: {
    bech32PrefixAccAddr: "zeta",
    bech32PrefixAccPub: "zetapub",
    bech32PrefixValAddr: "zetavaloper",
    bech32PrefixValPub: "zetavaloperpub",
    bech32PrefixConsAddr: "ezetaalcons",
    bech32PrefixConsPub: "zetavalconspub",
  },
  currencies: [
    {
      coinDenom: "ZETA",
      coinMinimalDenom: "azeta",
      coinDecimals: 18,
      coinGeckoId: "zetachain",
    },
  ],
  feeCurrencies: [
    {
      coinDenom: "ZETA",
      coinMinimalDenom: "azeta",
      coinDecimals: 18,
      coinGeckoId: "zetachain",
      gasPriceStep: {
        low: 80000000000,
        average: 80000000000,
        high: 80000000000,
      },
    },
  ],
  features: ["eth-address-gen", "eth-key-sign"],
  evm: {
    chainId: 7000,
    rpc: "https://evm-zetachain.keplr.app",
  },
};

export const XrplEvmChainInfo = {
  chainId: "xrplevm_1440000-1",
  chainName: "XRPL EVM",
  rpc: "https://rpc-xrplevm.keplr.app",
  rest: "https://lcd-xrplevm.keplr.app",
  stakeCurrency: {
    coinDenom: "XRP",
    coinMinimalDenom: "axrp",
    coinDecimals: 18,
    coinGeckoId: "ripple",
  },
  bip44: { coinType: 60 },
  bech32Config: {
    bech32PrefixAccAddr: "ethm",
    bech32PrefixAccPub: "ethmpub",
    bech32PrefixValAddr: "ethmvaloper",
    bech32PrefixValPub: "ethmvaloperpub",
    bech32PrefixConsAddr: "ethmvalcons",
    bech32PrefixConsPub: "ethmvalcons",
  },
  currencies: [
    {
      coinDenom: "XRP",
      coinMinimalDenom: "axrp",
      coinDecimals: 18,
      coinGeckoId: "ripple",
    },
  ],
  feeCurrencies: [
    {
      coinDenom: "XRP",
      coinMinimalDenom: "axrp",
      coinDecimals: 18,
      coinGeckoId: "ripple",
      gasPriceStep: {
        low: 200000000000,
        average: 250000000000,
        high: 400000000000,
      },
    },
  ],
  features: ["eth-address-gen", "eth-key-sign"],
  evm: {
    chainId: 1440000,
    rpc: "https://evm-xrplevm.keplr.app",
  },
};

export const EthermintChains = [
  { id: "zetachain", label: "ZetaChain", info: ZetaChainInfo },
  { id: "xrplevm", label: "XRPL EVM", info: XrplEvmChainInfo },
];
